document.addEventListener('DOMContentLoaded', () => {
  const C = window.verzielCart || {};

  const drawer       = document.getElementById('CartDrawer');
  const overlay      = document.getElementById('CartDrawerOverlay');
  const closeBtn     = document.getElementById('CartDrawerClose');
  const cartIcon     = document.getElementById('HeaderCartLink');
  const itemsContainer = document.getElementById('CartDrawerItems');
  const subtotalEl   = document.getElementById('CartDrawerSubtotal');
  const cartCountEl  = document.getElementById('HeaderCartCount');
  const buyBtnsEl    = document.getElementById('CartDrawerBuyButtons');
  const additionalBtnsEl = document.getElementById('CartAdditionalBtns');

  // ── Apply static settings from panel ──────────────────────────────

  // Header
  const headerEl = document.getElementById('CartDrawerHeader');
  const titleEl  = document.getElementById('CartDrawerTitle');
  if (headerEl) headerEl.style.display = C.showHeader === false ? 'none' : '';
  if (titleEl) {
    if (C.headerTitle && C.headerTitle.trim()) {
      titleEl.style.display = '';
      titleEl.textContent = C.headerTitle;
      titleEl.style.fontSize = (C.headerFontSize || 20) + 'px';
    } else {
      titleEl.style.display = 'none';
    }
  }

  // Subtotal row
  const subtotalRow = document.getElementById('CartSubtotalRow');
  const subtotalLabel = document.getElementById('CartSubtotalLabel');
  if (subtotalRow) subtotalRow.style.display = C.showSubtotal === false ? 'none' : '';
  if (subtotalLabel) {
    if (C.subtotalLabel && C.subtotalLabel.trim()) {
      subtotalLabel.style.display = '';
      subtotalLabel.textContent = C.subtotalLabel;
    } else {
      subtotalLabel.style.display = 'none';
    }
  }

  // Additional checkout buttons visibility
  if (additionalBtnsEl) {
    additionalBtnsEl.style.display = C.showAdditionalBtns === false ? 'none' : '';
  }

  // ── Build Buy Buttons ──────────────────────────────────────────────
  function buildBuyButtons() {
    if (!buyBtnsEl) return;
    buyBtnsEl.innerHTML = '';

    // Btn 1 — always shown (native checkout) unless disabled
    if (C.btn1Enabled !== false) {
      const btn1 = document.createElement('button');
      btn1.id = 'CartBtn1';
      btn1.className = 'vz-cart-btn w-full font-heading font-black uppercase tracking-widest transition-all hover:brightness-110 text-center';
      btn1.textContent = C.btn1Label || 'PAGAR';
    btn1.style.cssText = `
      display:block;
      background-color:${C.btn1Bg || '#adff00'};
      color:${C.btn1TextColor || '#000'};
      --fs-mobile: ${C.btn1FontSizeMobile || 14}px;
      --fs-desk: ${C.btn1FontSize || 15}px;
      --py-mobile: ${C.btn1PaddingYMobile || 14}px;
      --py-desk: ${C.btn1PaddingY || 16}px;
      border:none; cursor:pointer; width:100%; text-decoration:none;`;
      btn1.type = 'submit';
      btn1.setAttribute('form', 'CartDrawerCheckoutForm');
      buyBtnsEl.appendChild(btn1);
    }

    // Hidden checkout form — must be appended to body for form= attribute to work cross-browser
    let form = document.getElementById('CartDrawerCheckoutForm');
    if (!form) {
      form = document.createElement('form');
      form.id = 'CartDrawerCheckoutForm';
      form.action = '/cart/checkout';
      form.method = 'post';
      form.style.display = 'none';
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = 'checkout'; input.value = '1';
      form.appendChild(input);
      document.body.appendChild(form);
    }

    // Btn 2
    if (C.btn2Enabled) {
      const btn2 = document.createElement('a');
      btn2.className = 'vz-cart-btn w-full font-heading font-black uppercase tracking-widest transition-all hover:brightness-110 text-center';
      btn2.textContent = C.btn2Label || 'VER CARRITO';
      btn2.href = C.btn2Url || '/cart';
      btn2.style.cssText = `
        display:block;
        background-color:${C.btn2Bg || '#0b0d0a'};
        color:${C.btn2TextColor || '#fff'};
        border:1px solid ${C.btn2BorderColor || '#3b3d3a'};
        --fs-mobile: ${C.btn2FontSizeMobile || 12}px;
        --fs-desk: ${C.btn2FontSize || 13}px;
        --py-mobile: ${C.btn2PaddingYMobile || 10}px;
        --py-desk: ${C.btn2PaddingY || 12}px;
        text-decoration:none;`;
      buyBtnsEl.appendChild(btn2);
    }

    // Btn 3
    if (C.btn3Enabled) {
      const btn3 = document.createElement('button');
      btn3.className = 'vz-cart-btn w-full font-heading font-black uppercase tracking-widest transition-all hover:brightness-110 text-center';
      btn3.textContent = C.btn3Label || 'SEGUIR COMPRANDO';
      btn3.type = 'button';
      btn3.style.cssText = `
        background-color:${C.btn3Bg || '#0b0d0a'};
        color:${C.btn3TextColor || '#adff00'};
        border:1px solid ${C.btn3BorderColor || '#adff00'};
        --fs-mobile: ${C.btn3FontSizeMobile || 12}px;
        --fs-desk: ${C.btn3FontSize || 13}px;
        --py-mobile: ${C.btn3PaddingYMobile || 10}px;
        --py-desk: ${C.btn3PaddingY || 12}px;
        cursor:pointer; width:100%;`;
      if (C.btn3Url) {
        btn3.addEventListener('click', () => { window.location.href = C.btn3Url; });
      } else {
        btn3.addEventListener('click', closeCartDrawer);
      }
      buyBtnsEl.appendChild(btn3);
    }
  }
  buildBuyButtons();

  // ── Format money ───────────────────────────────────────────────────
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ── Sync cart count on load ────────────────────────────────────────
  function syncCartCount() {
    fetch('/cart.js', { cache: 'no-store' })
      .then(r => r.json())
      .then(cart => { if (cartCountEl) cartCountEl.textContent = cart.item_count; })
      .catch(() => {});
  }
  syncCartCount();

  // ── Open / Close ───────────────────────────────────────────────────
  function openCartDrawer() {
    if (!drawer) return;
    drawer.classList.remove('translate-x-full');
    overlay.classList.remove('opacity-0', 'pointer-events-none');
    document.body.style.overflow = 'hidden';
    fetchCart();
    document.dispatchEvent(new Event('cartDrawerOpened'));
  }
  function closeCartDrawer() {
    if (!drawer) return;
    drawer.classList.add('translate-x-full');
    overlay.classList.add('opacity-0', 'pointer-events-none');
    document.body.style.overflow = '';
  }

  window.openCartDrawer = openCartDrawer;
  window.refreshCartDrawer = fetchCart;

  if (cartIcon) cartIcon.addEventListener('click', e => { e.preventDefault(); openCartDrawer(); });
  if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
  if (overlay) overlay.addEventListener('click', closeCartDrawer);

  // ── Fetch cart ─────────────────────────────────────────────────────
  function fetchCart() {
    itemsContainer.innerHTML = `
      <div class="text-center text-gray-500 py-10 font-sans text-sm">
        <div class="inline-block animate-spin w-6 h-6 border-2 border-[#adff00] border-t-transparent rounded-full mb-4"></div>
        <p>Cargando...</p>
      </div>`;
    fetch('/cart.js')
      .then(r => r.json())
      .then(renderCart)
      .catch(err => console.error('Cart fetch error:', err));
  }

  // ── Render cart ────────────────────────────────────────────────────
  const thumbSize = C.thumbSize || 80;

  function renderCart(cart) {
    if (cartCountEl) cartCountEl.textContent = cart.item_count;
    if (subtotalEl)  subtotalEl.textContent = formatMoney(cart.total_price);

    if (cart.items.length === 0) {
      // Hide gift banner and footer when cart is empty
      const giftBanner = document.getElementById('CartGiftBanner');
      const footer = document.getElementById('CartDrawerFooter');
      if (giftBanner) giftBanner.style.display = 'none';
      if (footer) footer.style.display = 'none';

      const badge    = C.emptyBadge;
      const headline = C.emptyHeadline;
      const subtext  = C.emptySubtext;
      const proof    = C.emptySocialProof;
      const ctalbl   = C.emptyCtaLabel;
      const guarantee= C.emptyGuarantee;

      itemsContainer.innerHTML = `
        <div style="display:flex;flex-direction:column;align-items:center;padding:28px 16px 16px;text-align:center;">
          <div style="position:relative;margin-bottom:16px;">
            <div style="position:absolute;inset:0;background:radial-gradient(circle,rgba(173,255,0,0.18) 0%,transparent 70%);border-radius:50%;transform:scale(2);pointer-events:none;"></div>
            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 24 24" fill="none" stroke="#adff00" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" style="position:relative;opacity:0.9;">
              <circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/>
              <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/>
            </svg>
          </div>
          ${badge && badge.trim() ? `<div style="display:inline-flex;align-items:center;gap:6px;background:#111410;border:1px solid rgba(173,255,0,0.3);padding:4px 12px;margin-bottom:14px;">
            <span style="width:6px;height:6px;background:#adff00;border-radius:50%;display:inline-block;animation:ping 1s cubic-bezier(0,0,0.2,1) infinite;"></span>
            <span style="color:#adff00;font-size:9px;font-weight:900;letter-spacing:0.15em;text-transform:uppercase;font-family:'Chakra Petch',sans-serif;">${badge}</span>
          </div>` : ''}
          ${headline && headline.trim() ? `<p style="color:#fff;font-size:16px;font-weight:900;text-transform:uppercase;letter-spacing:0.08em;margin:0 0 8px;line-height:1.2;font-family:'Chakra Petch',sans-serif;">${headline}</p>` : ''}
          ${subtext && subtext.trim() ? `<p style="color:#9ca3af;font-size:12px;margin:0 0 18px;line-height:1.6;max-width:240px;">${subtext}</p>` : ''}
          ${proof && proof.trim() ? `<div style="display:flex;align-items:center;gap:8px;margin-bottom:20px;">
            <div style="display:flex;">
              ${['V','M','J','R','L'].map(l => `<div style="width:24px;height:24px;border-radius:50%;background:#1a1f14;border:2px solid #0b0d0a;display:flex;align-items:center;justify-content:center;margin-left:-6px;font-size:9px;color:#adff00;font-weight:900;font-family:'Chakra Petch',sans-serif;">${l}</div>`).join('')}
            </div>
            <span style="color:#6b7280;font-size:10px;font-family:sans-serif;">${proof}</span>
          </div>` : ''}
          ${ctalbl && ctalbl.trim() ? `<a href="/collections/all" style="width:100%;background:#adff00;color:#000;border:none;cursor:pointer;padding:14px 20px;font-family:'Chakra Petch',sans-serif;font-weight:900;font-size:13px;letter-spacing:0.12em;text-transform:uppercase;transition:background 0.2s;text-decoration:none;display:block;text-align:center;" onmouseover="this.style.background='#ccff00'" onmouseout="this.style.background='#adff00'">${ctalbl}</a>` : ''}
          ${guarantee && guarantee.trim() ? `<p style="color:#4b5563;font-size:10px;margin:10px 0 0;font-family:sans-serif;">${guarantee}</p>` : ''}
        </div>`;
      const cb = document.getElementById('ContinueShoppingBtn');
      if (cb) cb.addEventListener('click', closeCartDrawer);
      return;
    }

    // Cart has items — restore footer visibility
    const footer2 = document.getElementById('CartDrawerFooter');
    if (footer2) footer2.style.display = '';

    // --- DYNAMIC GIFT LOGIC ---
    let hasGift = false;
    let autoGiftName = '';
    let autoGiftImage = null;

    cart.items.forEach(item => {
      const titleLower = item.product_title.toLowerCase();
      if (item.price === 0) {
        hasGift = true;
        if (!autoGiftName) {
          autoGiftName = item.product_title;
          autoGiftImage = item.image;
        }
      } else if (titleLower.includes('bonus') || titleLower.includes('bundle') || titleLower.includes('pack')) {
        hasGift = true;
        if (!autoGiftName) autoGiftName = item.product_title;
      }
    });

    // Smart defaults: if panel has custom name use it, else use auto-detected product name
    const giftDisplayName = (C.giftProductName && C.giftProductName.trim()) ? C.giftProductName : autoGiftName;
    const giftDisplayImage = C.giftImage || (autoGiftImage && hasGift ? autoGiftImage : null);

    // giftEnabled defaults to true if not explicitly set to false
    const giftEnabled = C.giftEnabled !== false;
    const giftCardShow = C.giftCardShow !== false;

    const bannerWrap = document.getElementById('CartGiftBanner');
    const card = document.getElementById('CartGiftBannerCard');
    if (bannerWrap) bannerWrap.style.display = 'block';

    if (card) {
      if (giftEnabled && giftCardShow && hasGift) {
        card.style.display = 'block';

        const bannerInner = document.getElementById('CartGiftBannerInner');
        if (bannerInner) {
          bannerInner.style.backgroundColor = C.giftBannerBg || '#111410';
          bannerInner.style.borderColor = C.giftBannerBorder || '#adff00';
        }

        // Image wrap — supports SVG icon, emoji, or product image
        const imageWrap = document.getElementById('CartGiftImageWrap');
        const emojiEl = document.getElementById('CartGiftEmoji');
        if (imageWrap) {
          const imgSize = C.giftImageSize || 56;
          imageWrap.style.width = imgSize + 'px';
          imageWrap.style.height = imgSize + 'px';
          imageWrap.style.display = '';

          if (giftDisplayImage) {
            imageWrap.innerHTML = `<img src="${giftDisplayImage}" alt="" style="width:100%;height:100%;object-fit:cover;">`;
          } else if (C.giftBadgeType === 'emoji') {
            const badge = (C.giftBadgeText && C.giftBadgeText.trim()) ? C.giftBadgeText : '🎁';
            imageWrap.innerHTML = `<span style="font-size:1.5rem;">${badge}</span>`;
          } else {
            // SVG icon
            const iconColor = C.giftBadgeIconColor || '#adff00';
            const svgMap = {
              'gift': `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="${iconColor}" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"/></svg>`,
              'star': `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="${iconColor}" stroke="${iconColor}" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>`,
              'check-circle': `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="${iconColor}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><path d="m9 11 3 3L22 4"/></svg>`,
              'trophy': `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="${iconColor}" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/><path d="M4 22h16"/><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/><path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"/></svg>`,
              'crown': `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="${iconColor}" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m2 4 3 12h14l3-12-6 7-4-7-4 7-6-7zm3 16h14"/></svg>`,
              'rocket': `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="${iconColor}" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/></svg>`,
              'lightning': `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="${iconColor}" stroke="${iconColor}" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>`,
              'heart': `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="${iconColor}" stroke="${iconColor}" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>`,
              'shield': `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="${iconColor}" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>`,
              'cart': `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="${iconColor}" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>`,
              'download': `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="${iconColor}" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>`
            };
            const svgHtml = svgMap[C.giftBadgeIcon || 'gift'] || svgMap['gift'];
            imageWrap.innerHTML = svgHtml;
          }
        }

        // Headline
        const headlineEl = document.getElementById('CartGiftHeadline');
        if (headlineEl) {
          const headline = (C.giftHeadline && C.giftHeadline.trim()) ? C.giftHeadline : 'Congratulations! Your order includes:';
          const showHeadline = C.giftShowHeadline !== false;
          headlineEl.style.display = showHeadline ? '' : 'none';
          headlineEl.textContent = headline;
          headlineEl.style.color = C.giftFreeColor || '#adff00';
        }

        // Product name
        const nameEl = document.getElementById('CartGiftProductName');
        if (nameEl) {
          const showName = C.giftShowProductName !== false;
          if (showName && giftDisplayName && giftDisplayName.trim()) {
            nameEl.style.display = '';
            nameEl.textContent = giftDisplayName;
            nameEl.style.color = C.giftTitleColor || '#ffffff';
          } else {
            nameEl.style.display = 'none';
          }
        }

        // Price row
        const priceEl = document.getElementById('CartGiftOriginalPrice');
        const freeLblEl = document.getElementById('CartGiftFreeLabel');
        const priceRow = priceEl && priceEl.parentElement;
        const showPriceRow = C.giftShowPriceRow !== false;

        if (priceRow) {
          const hasOriginal = C.giftOriginalPrice && C.giftOriginalPrice.trim();
          const hasFree = C.giftFreeLabel && C.giftFreeLabel.trim();
          // Only show price row if panel has values set
          priceRow.style.display = (showPriceRow && (hasOriginal || hasFree)) ? '' : 'none';
        }
        if (priceEl) {
          const hasOriginal = C.giftOriginalPrice && C.giftOriginalPrice.trim();
          priceEl.style.display = hasOriginal ? '' : 'none';
          if (hasOriginal) { priceEl.textContent = C.giftOriginalPrice; priceEl.style.color = C.giftPriceColor || '#6b7280'; }
        }
        if (freeLblEl) {
          const freeText = (C.giftFreeLabel && C.giftFreeLabel.trim()) ? C.giftFreeLabel : 'FREE';
          freeLblEl.style.display = '';
          freeLblEl.textContent = freeText;
          freeLblEl.style.color = C.giftFreeColor || '#adff00';
        }

      } else {
        card.style.display = 'none';
      }
    }
    // --- END DYNAMIC GIFT LOGIC ---

    let html = '';
    cart.items.forEach(item => {
      const isFree = item.price === 0;
      const imgHtml = item.image
        ? `<img src="${item.image}" alt="${item.product_title}" style="width:${thumbSize}px;height:${thumbSize}px;object-fit:cover;" class="border border-[#3b3d3a] shrink-0">`
        : `<div style="width:${thumbSize}px;height:${thumbSize}px;" class="bg-[#111410] border border-[#3b3d3a] shrink-0"></div>`;

      const variantHtml = item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="text-xs text-gray-500 font-sans mb-1">${item.variant_title}</p>` : '';

      // Free badge + price display for free items
      const freeBadgeHtml = (isFree && C.freeBadgeEnabled && C.freeBadgeText && C.freeBadgeText.trim())
        ? `<span class="vz-free-badge" style="background-color:${C.freeBadgeBg || '#adff00'};color:${C.freeBadgeTextColor || '#000'};"> ${C.freeBadgeText}</span>` : '';

      // Price display
      let priceHtml;
      if (isFree) {
        // FREE item: show crossed-out original price + FREE label
        const freeColor = C.freePriceColor || '#adff00';
        const freeCompareColor = C.freePriceCompareColor || '#6b7280';
        priceHtml = `<span class="vz-compare-price-free" data-compare-key="${item.key}" data-free-color="${freeColor}" data-compare-color="${freeCompareColor}"></span><span style="color:${freeColor};" class="font-sans text-sm font-bold">FREE${freeBadgeHtml}</span>`;
      } else {
        // Paid item: show compare price slot + current price + % OFF badge
        priceHtml = `<span class="vz-compare-price" data-compare-key="${item.key}" data-quantity="${item.quantity}"></span><span class="text-[#adff00] font-sans text-sm font-bold">${formatMoney(item.line_price)}</span><span class="vz-off-badge" data-compare-key="${item.key}" data-item-price="${item.price}"></span>`;
      }

      html += `
        <div class="flex gap-4 items-start pb-6 border-b border-[#3b3d3a]/30 relative group">
          ${imgHtml}
          <div class="flex-1 min-w-0 pr-6">
            <h3 class="text-sm font-heading font-bold text-white uppercase tracking-wider truncate mb-1" title="${item.product_title}">${item.product_title}</h3>
            ${variantHtml}
            <div class="flex items-baseline gap-1 mb-3">${priceHtml}</div>
            <div class="flex items-center border border-[#3b3d3a] bg-[#111410] w-fit">
              <button class="cart-qty-btn px-2 py-1 text-gray-400 hover:text-white transition-colors" data-line="${item.key}" data-qty="${item.quantity - 1}">-</button>
              <span class="text-xs font-mono text-white px-2 w-6 text-center">${item.quantity}</span>
              <button class="cart-qty-btn px-2 py-1 text-gray-400 hover:text-white transition-colors" data-line="${item.key}" data-qty="${item.quantity + 1}">+</button>
            </div>
          </div>
          <button class="cart-remove-btn absolute top-0 right-0 text-gray-500 hover:text-[#ff3333] transition-colors p-1" data-line="${item.key}" aria-label="Remove">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/></svg>
          </button>
        </div>`;
    });
    itemsContainer.innerHTML = html;
    fetchComparePrices(cart);

    document.querySelectorAll('.cart-qty-btn, .cart-remove-btn').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const key = this.getAttribute('data-line');
        const qty = this.classList.contains('cart-remove-btn') ? 0 : parseInt(this.getAttribute('data-qty'));
        updateItem(key, qty);
      });
    });
  }

  // ── Compare prices ─────────────────────────────────────────────────
  const productCache = {};
  function fetchComparePrices(cart) {
    const handles = [...new Set(cart.items.map(i => i.handle))];
    Promise.all(handles.map(h => {
      if (productCache[h]) return Promise.resolve(productCache[h]);
      return fetch(`/products/${h}.js`).then(r => r.ok ? r.json() : null)
        .then(p => { productCache[h] = p; return p; }).catch(() => null);
    })).then(() => {
      cart.items.forEach(item => {
        const isFree = item.price === 0;
        const product = productCache[item.handle];
        if (!product) return;
        const variant = product.variants.find(v => v.id === item.variant_id);

        if (isFree) {
          // Fill free item's compare price slot
          if (!C.freePriceEnabled) return;
          const slot = itemsContainer.querySelector(`.vz-compare-price-free[data-compare-key="${item.key}"]`);
          if (!slot) return;
          const comparePrice = variant && variant.compare_at_price ? parseFloat(variant.compare_at_price) : null;
          if (comparePrice && comparePrice > 0) {
            const freeCompareColor = slot.getAttribute('data-compare-color') || '#6b7280';
            slot.innerHTML = `<span style="color:${freeCompareColor};text-decoration:line-through;font-size:11px;font-family:sans-serif;margin-right:4px;">${formatMoney(comparePrice * item.quantity)}</span>`;
          }
        } else {
          // Paid item: fill compare price + % OFF badge
          if (!variant) return;

          // Compare price slot
          if (variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price)) {
            const slot = itemsContainer.querySelector(`.vz-compare-price[data-compare-key="${item.key}"]`);
            if (slot) slot.innerHTML = `<span class="text-gray-500 line-through text-xs font-sans mr-1">${formatMoney(parseFloat(variant.compare_at_price) * item.quantity)}</span>`;

            // % OFF badge
            if (C.offBadgeEnabled !== false) {
              const offSlot = itemsContainer.querySelector(`.vz-off-badge[data-compare-key="${item.key}"]`);
              if (offSlot) {
                const pct = Math.round((1 - parseFloat(variant.price) / parseFloat(variant.compare_at_price)) * 100);
                if (pct > 0) {
                  offSlot.innerHTML = `<span style="display:inline-block;background:${C.offBadgeBg || '#ff3333'};color:${C.offBadgeTextColor || '#fff'};font-size:9px;font-weight:900;letter-spacing:.06em;padding:2px 5px;margin-left:4px;font-family:'Chakra Petch',sans-serif;vertical-align:middle;">-${pct}%</span>`;
                }
              }
            }
          }
        }
      });
    });
  }

  // ── Update item ────────────────────────────────────────────────────
  function updateItem(key, quantity) {
    itemsContainer.style.opacity = '0.5';
    itemsContainer.style.pointerEvents = 'none';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    })
    .then(r => r.json())
    .then(cart => {
      itemsContainer.style.opacity = '1';
      itemsContainer.style.pointerEvents = 'auto';
      renderCart(cart);
    })
    .catch(() => {
      itemsContainer.style.opacity = '1';
      itemsContainer.style.pointerEvents = 'auto';
    });
  }

  // ── Intercept add-to-cart forms ────────────────────────────────────
  document.addEventListener('submit', function(e) {
    const form = e.target;
    const action = form.getAttribute('action');
    // Only intercept add-to-cart forms, NOT checkout forms
    if (!action || !action.includes('/cart/add')) return;
    e.preventDefault();
    const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
    const originalText = submitBtn ? submitBtn.innerHTML : '';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.innerHTML = '<span class="inline-block animate-spin w-4 h-4 border-2 border-black border-t-transparent rounded-full"></span>'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(() => {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = originalText; }
        openCartDrawer();
      })
      .catch(() => {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = originalText; }
        alert('Error adding item to cart.');
      });
  });

  // ── Topbar Timer ───────────────────────────────────────────────────
  (function initTopbarTimer() {
    const bannerWrap = document.getElementById('CartGiftBanner');
    if (bannerWrap) bannerWrap.style.display = 'block';

    const topbar = document.getElementById('CartGiftTopbar');
    const timerEl = document.getElementById('CartGiftTimer');
    const topbarLbl = document.getElementById('CartGiftTopbarLabel');

    if (C.giftTopbarShow && topbar) {
      topbar.style.display = 'flex';
      topbar.style.backgroundColor = C.giftTopbarBg;
      topbar.style.color = C.giftTopbarText;
      if (topbarLbl) {
        if (C.giftTopbarLabel && C.giftTopbarLabel.trim()) {
          topbarLbl.style.display = '';
          topbarLbl.textContent = C.giftTopbarLabel;
        } else {
          topbarLbl.style.display = 'none';
        }
      }
    } else if (topbar) {
      topbar.style.display = 'none';
    }

    if (C.giftTopbarShow && timerEl) {
      let totalSeconds = (C.giftTimerMinutes || 10) * 60;
      let interval = null;
      function startTimer() {
        clearInterval(interval);
        totalSeconds = (C.giftTimerMinutes || 10) * 60;
        tick();
        interval = setInterval(tick, 1000);
      }
      function tick() {
        const m = Math.floor(totalSeconds / 60), s = totalSeconds % 60;
        timerEl.textContent = `${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
        if (totalSeconds > 0) totalSeconds--;
        else clearInterval(interval);
      }
      document.addEventListener('cartDrawerOpened', startTimer);
    }
  })();

});
